import axios, { AxiosError, AxiosRequestConfig } from "axios"
import {
  requestInterceptorErrorSecurityCredentials,
  requestInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials,
  responseInterceptorSuccessCredentials,
} from "interceptors"
import {
  LEDGER_PATH,
  SALE_REPORT_EXPORT_PATH,
  SALE_REPORT_PATH,
  SUMMARY_EXPORT_PATH,
  SUMMARY_PATH,
  UPLOAD_PATH,
} from "../../constants/paths"
import { UploadResponse } from "types/response"
import { ISaleReportResponse } from "types/response/saleReportResponse"

const instance = axios.create({
  baseURL: process.env.REACT_APP_DOCUMENTS_API_SERVICE_DOMAIN,
})
instance.interceptors.request.use(
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials,
)

instance.interceptors.response.use(
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials,
)

const formDataConfig: AxiosRequestConfig = {
  headers: {
    "Content-Type": "multipart/form-data",
  },
}

export const uploadLegderDataService = async (
  file: File | null,
): Promise<UploadResponse> => {
  const formData = new FormData()
  if (file) {
    formData.append("file", file)
  }

  // Se elimina el try/catch para que el componente maneje el error
  const result = await instance.post<UploadResponse>(
    LEDGER_PATH + UPLOAD_PATH,
    formData,
    formDataConfig,
  )
  return result.data
}

export const getLedgerSummaryService = async (params: any) => {
  try {
    const result = await instance.get(LEDGER_PATH + SUMMARY_PATH, {
      params,
    })
    return result.data
  } catch (error: any) {
    console.error("Error en getLedgerSummaryService:", error)
    const e: AxiosError = error
    //  mensaje de error del backend
    throw new Error(
      e.response?.data?.message ||
        "Error al obtener el resumen del libro mayor",
    )
  }
}

export const getSaleReportService = async (params: any) => {
  try {
    const result = await instance.get(LEDGER_PATH + SALE_REPORT_PATH, {
      params,
    })
    return result.data as ISaleReportResponse
  } catch (error: any) {
    console.error("Error en getSaleReportService:", error)
    const e: AxiosError = error
    throw new Error(
      e.response?.data?.message || "Error al obtener el reporte de ventas",
    )
  }
}

export const exportSummaryReportService = async (
  params: {
    year?: string | number
    month?: number
    quincena?: number
    invoiceNumber?: string
    rif?: string
    clientName?: string
    grouped?: boolean
  },
  emails: string[],
): Promise<void> => {
  try {
    await instance.post(LEDGER_PATH + SUMMARY_EXPORT_PATH, null, {
      params: { ...params, emails: emails.join(",") },
    })
  } catch (error: any) {
    console.error("Error en exportSummaryReportService:", error)
    const e: AxiosError = error
    throw new Error(
      e.response?.data?.message || "Error al solicitar el reporte de resumen",
    )
  }
}

export const exportSaleReportService = async (
  params: {
    year?: string | number
    month?: number
    quincena?: number
    invoiceNumber?: string
    rif?: string
    clientName?: string
  },
  emails: string[],
): Promise<void> => {
  try {
    await instance.post(LEDGER_PATH + SALE_REPORT_EXPORT_PATH, null, {
      params: { ...params, emails: emails.join(",") },
    })
  } catch (error: any) {
    console.error("Error en exportSaleReportService:", error)
    const e: AxiosError = error
    throw new Error(
      e.response?.data?.message || "Error al solicitar el reporte de ventas",
    )
  }
}
